<template>
  <div>
    <div class="foundation-info" v-if="isMobile == 'pc'">
      <div style="" class="foundation-info-top">
        <el-row v-if="screenWidth>640" :gutter="20" style="display: flex;align-items: center;justify-content: center;">
          <el-col :span="14">
            <div style="display: flex;align-items: center;justify-content: center;width:100%;">
              <div>
                <h2>{{aboutFoundation.title}}</h2>
                <div style="font-size: 1.2rem;margin-top: 2rem;">
                  <span v-html="aboutFoundation.content"></span>
                </div>
              </div>
              </div>
          </el-col>
          <el-col :span="10">
            <img style="width: 100%;border-radius: 0.5rem;" :src="aboutFoundation.imgUrl" alt="">
          </el-col>
        </el-row>
        <el-row v-else :gutter="10">
          <div style="text-align: center">
            <h2>{{aboutFoundation.title}}</h2>
          </div>
          <el-col :span="24">
            <img style="width: 100%;border-radius: 0.5rem;" :src="aboutFoundation.imgUrl" alt="">
          </el-col>
          <el-col :span="24">
            <div style="display: flex;align-items: center;justify-content: center;width:100%;">
              <div>
                <div style="font-size: 1.2rem;margin-top: 1rem;">
                  <span v-html="aboutFoundation.content"></span>
                </div>
              </div>
              </div>
          </el-col>
        </el-row>
      </div>
      
      <div>
        <div class="foundation-info-middle">
          <h2>{{ $t('FoundationPurpose') }}</h2>
        </div>
      </div>
      <div class="foundation-info-bottom">
        <el-row :gutter="20" class="mission">
          <el-col :span="screenWidth>540?6:12" v-for="(item,index) in missions" :key="item.title" :style="{'margin-top': screenWidth<=540 && index > 1?'5rem':'',}">
            <div class="foundation-info-bottom-card">
              <div class="foundation-info-bottom-card-icon">
                <img :src="item.imgUrl" width="100%" height="100%"/>
              </div>
              <div class="text-max-5 foundation-info-bottom-card-text">{{ item.digest }}</div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
    <!-- 移动端 -->
    <div class="foundation-info-mobile" v-if="isMobile == 'mobile'">
      <div style="" class="foundation-info-top-mobile">
        <div>
          <div style="text-align: center">
            <div style="font-size:18px;font-weight:800; padding:20px 0;">{{aboutFoundation.title}}</div>
          </div>
          <div style="background:#f8f8f8;border-radius:8px;">
            <img style="width: 100%;" :src="aboutFoundation.imgUrl" alt="">
            <div>
              <div style="display: flex;align-items: center;justify-content: center;width:100%;">
                <div>
                  <div style="font-size: 1.2rem;padding:0 10px;">
                    <span v-html="aboutFoundation.content"></span>
                  </div>
                </div>
                </div>
            </div>
          </div>
          
        </div>
      </div>
      
      <div>
        <div class="foundation-info-middle-mobile">
          <div class="middle-mobile-title">{{ $t('FoundationPurpose') }}</div>
        </div>
      </div>
      <div class="foundation-info-bottom" style="padding: 0 18px;">
        <el-row :gutter="20" class="mission">
          <el-col :span="12" v-for="(item,index) in missions" :key="item.title" :style="{'margin-top': index > 1 ? '5rem':'',}">
            <div class="foundation-info-bottom-card-mobile">
              <div class="foundation-info-bottom-card-icon">
                <img :src="item.imgUrl" width="100%" height="100%"/>
              </div>
              <div class="text-max-5 foundation-info-bottom-card-text">{{ item.digest }}</div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
  
</template>

<script>
import { listInfo } from '@/api/index';
import { mapState } from 'vuex'
export default {
  computed: {
    ...mapState(['screenWidth']),
    isMobile() {
        const userAgentInfo = navigator.userAgent;
        const agents = ["Android", "iPhone", "SymbianOS", "Windows Phone", "iPad", "iPod"];
        for (let i = 0; i < agents.length; i++) {
            if (userAgentInfo.indexOf(agents[i]) > -1) {
                return 'mobile'; // 移动端
            }
        }
        return 'pc'; // PC端
    }
  },
  data() {
    return {
	  aboutFoundation: {},
      missions: []
    };
  },
  mounted() {
	  //关于萨马兰奇体育发展基金会
	this.getAboutFoundation();
	//基金会宗旨
	this.getFoundationPurpose()
  },
  methods: {
	 getAboutFoundation() {
		 const formData = new FormData();
		 formData.append("moduleId", 17);
		 listInfo(formData).then(res => {
		   if (res.data && res.data != null) {
		     this.aboutFoundation = res.data[0];
		   }
		 })
	  },
	  getFoundationPurpose() {
	  		 const formData = new FormData();
	  		 formData.append("moduleId", 20);
	  		 listInfo(formData).then(res => {
	  		   if (res.data && res.data != null) {
	  		     this.missions = res.data;
	  		   }
	  		 })
	   },
  }
};
</script>

<style lang="less" scoped>
.foundation-info{
  background: #fff!important;
  width: 80%;
  margin: 0 auto;
}
.foundation-info {
  .foundation-info-top-mobile{
    background: #fff!important;
    padding: 0 18px;
  }
  .foundation-info-top{
    padding: 3rem 1rem;
    // background: linear-gradient(to bottom, #F9F9FA, white);
    background: #f8f8f8;
    border-radius: 0.4rem;
  }
  .foundation-info-middle-mobile{
    // height: 8rem;
    // line-height: 10rem;
    // padding-bottom: 3rem;
    padding: 40px 0 50px;
    text-align: center;
    .middle-mobile-title{
      font-size: 18px;
      font-weight: 800;
    }
  }
  .foundation-info-middle{
    height: 8rem;
    line-height: 10rem;
    padding-bottom: 3rem;
    margin-left: 2rem;
    text-align: center;
  }
  .foundation-info-bottom{
    .foundation-info-bottom-card-mobile{
      position: relative;
      border-radius: 0.4rem;
      width: 100%;
      height: 15rem;
      background: #f8f8f8;
      box-sizing: border-box;
      padding: 3rem 1.5rem;
      line-height: 1.7rem;
      .foundation-info-bottom-card-icon{
        width: 25%;
        transform: translateY(-50%);
        position: absolute;
        top: 0;
        left: 37.5%;
        overflow: hidden;
      }
      .foundation-info-bottom-card-text{
        margin-top: 2rem;
      }
    }
    .foundation-info-bottom-card{
      position: relative;
      border-radius: 0.4rem;
      width: 100%;
      height: 15rem;
      background: #f8f8f8;
      box-sizing: border-box;
      padding: 3rem 1.5rem;
      line-height: 1.7rem;
      .foundation-info-bottom-card-icon{
        width: 25%;
        transform: translateY(-50%);
        position: absolute;
        top: 0;
        left: 37.5%;
        overflow: hidden;
      }
      .foundation-info-bottom-card-text{
        margin-top: 2rem;
      }
    }
  }
}
</style>